import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Checkbox } from "primereact/checkbox";
import { Calendars } from "../../../components/Calendar/Calendar";
import { DialogConfirm, DialogViewPic } from "../../../components/DialogService/DialogService";
import { FooterButtonSigle, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { formatDateConvert } from "../../../utilities/DateUtil";

//PAGE
import P204List_1 from "./P204List_1";
import P204List_2 from "./P204List_2";

//SERVICE
import { pSupervisorReport2_Info, pSupervisorReport2_Update } from "../../../service/200/P204Service";
import { genPhotoList } from "../../../service/GEN/GenService";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P204() {
    const toast = useRef(null);
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);
    // DIALOG
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    // DATA
    const [formArray, setFormArray] = useState([]);
    const [dataTbImage, setDataTbImage] = useState([]);
    const [supervisorReason, setSupervisorReason] = useState(""); // date
    const [reportDtBegin, setReportDtBegin] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "09", "00"));
    const [reportDtEnd, setReportDtEnd] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "16", "00"));

    // SEARCH
    const [searchData, setSearchData] = useState({
        requestNo: "",
        userId: "",
    });

    // View Pic
    const [dialogPic, setDialogPic] = useState({ dialog: false, pic: "", show: false });
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({ ...history.location.state, userId: dataUserSession().userId });
            } else {
                history.push("/200");
                // setSearchData({ requestNo: "R651600010", userId: dataUserSession().userId });
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData.requestNo !== "") {
            getSupervisorReport2_Info();
            getGenPhotoList();
        }
    }, [searchData]);

    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const getSupervisorReport2_Info = () => {
        setLoading(true);

        const req = {
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };
        pSupervisorReport2_Info(req).then(
            (res) => {
                // console.log(res);
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 0;
                    res.data.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });

                    if (res.data.length > 0) {
                        setSupervisorReason(temp[0].supervisorReason);
                        if (temp[0].reportDtBegin !== null) setReportDtBegin(formatDateConvert(temp[0].reportDtBegin));
                        if (temp[0].operateTimeEnd !== null) setReportDtBegin(formatDateConvert(temp[0].operateTimeEnd));
                    }

                    setFormArray(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getGenPhotoList = () => {
        const req = {
            userId: searchData.userId,
            requestNo: searchData.requestNo,
            photoType: "S901",
            // S901 C001
        };

        genPhotoList(req).then(
            (res) => {
                setLoading(false);

                if (res !== undefined) {
                    let temp = [];
                    let index = 0;
                    if (res.data.length) {
                        res.data.forEach((element) => {
                            temp.push({
                                ...element,
                                index: index,
                            });
                            index++;
                        });
                        setDataTbImage(temp);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const footerButtonSingle = () => {
        const con = () => {
            // alert("/200");
            history.push("/200");
            setConfirmDialog(false);
        };
        return <FooterButtonSigle btnLabel="ปิด" icon="pi pi-check" onClick={() => con()} />;
    };

    const validation = (val) => {
        if (val === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const submitForm = (act) => {
        setLoading(true);

        const req = {
            actionCode: act,
            requestNo: searchData.requestNo,
            supervisorReason: supervisorReason,
            userId: searchData.userId,

            recordStamp: setValViewForm("recordStamp"),
        };
        // console.log(req);
        pSupervisorReport2_Update(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    handlerSettingDialogConfirm(res.data[0].statusCode === "C" ? "บันทึกสมบูรณ์" : "มีข้อผิดพลาด", res.data[0].statusText);
                } else {
                    showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                    window.location.href = "/login";
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด : ${err} `, "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
                setLoading(false);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const setValViewForm = (_key) => {
        return formArray.length > 0 ? formArray[0][_key] : "";
    };

    const viewImage = (event) => {
        setDialogPic({
            dialog: true,
            show: true,
            pic: event.photoPath,
        });
    };

    const footerButtonCon = (act) => {
        return (
            <FooterButtonCustomLabel
                labelCon="ยืนยัน"
                lableCan="ยกเลิก"
                onClickOk={() => {
                    submitForm(act);
                    setConfirmDialog({ open: false });
                }}
                onClickCancle={() => setConfirmDialog(false)}
            />
        );
    };

    const handlerSettingDialogConfirm_2 = (key, _content) => {
        if (key === "R") {
            if (!validation(supervisorReason)) {
                return true;
            }
        }

        setdialogOption({
            ...dialogOption,
            header: "",
            content: _content,
            footerBtn: () => footerButtonCon(key),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const disPlayMode = () => {
        // return false;
        // console.log(setValViewForm("displayMode") );
        return setValViewForm("displayMode") === "Y" || setValViewForm("displayMode") === "" ? true : false;
    };
    const disPlayMode_R = () => {
        // return false;
        if (setValViewForm("displayMode") === "Y") {
            return true;
        } else {
            if (supervisorReason === "") {
                return true;
            } else {
                return false;
            }
        }
    };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เลขที่ใบแจ้งฯ</label>
                                <InputText id="requestNo" type="text" disabled={true} maxLength="20" value={setValViewForm("requestNo")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestType">ประเภทงาน</label>
                                <InputText id="requestType" type="text" disabled={true} maxLength="100" value={setValViewForm("requestType")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="originalRequestNo">เลขที่ใบแจ้งฯต้นเรื่อง</label>
                                <InputText id="originalRequestNo" type="text" disabled={true} maxLength="100" value={setValViewForm("originalRequestNo")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" disabled={true} maxLength="20" value={setValViewForm("contractNo")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeName">เส้นทาง</label>
                                <InputText id="routeName" type="text" disabled={true} maxLength="200" value={setValViewForm("routeName")} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid p-formgrid p-grid">
                            <label htmlFor="orderDetail">งานสั่งการเฉพาะอย่าง</label>
                            <P204List_1 dataTable={formArray} />
                        </div>

                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="guidelineCheckbox" checked={setValViewForm("guidelineCheckbox") === "Y" ? true : false} disabled={true} />
                                    <label htmlFor="guidelineCheckbox">เพื่อเป็นแนวทางปฏิบัติ</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-2">
                                <InputText id="guidelineNo" type="text" value={setValViewForm("guidelineNo")} disabled={true} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="fixExpireCheckbox" 
                                    checked={setValViewForm("fixExpireCheckbox") === "Y" ? true : false} disabled={true} />
                                    <label htmlFor="fixExpireCheckbox">เพื่อปรับปรุงแก้ไขภายในวันที่</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-2">
                                <InputText id="fixExpireDate" type="text" value={setValViewForm("fixExpireDate")} disabled={true} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-3">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="urgentFixExpireCheckbox" checked={setValViewForm("urgentFixExpireCheckbox") === "Y" ? true : false} disabled={true} />
                                    <label htmlFor="urgentFixExpireCheckbox">เพื่อเร่งรัดดำเนินการโดยด่วน ภายในวันที่</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-2">
                                <InputText id="urgentFixExpireDate" type="text" value={setValViewForm("urgentFixExpireDate")} disabled={true} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-3">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="replyCheckbox" checked={setValViewForm("replyCheckbox") === "Y" ? true : false} disabled={true} />
                                    <label htmlFor="replyCheckbox">โปรดตอบเป็นหนังสือภายในวันที่</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-2">
                                <InputText id="replyExpireDate" type="text" value={setValViewForm("replyExpireDate")} disabled={true} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="replyWithinDay">แก้ไขภายในวันที่</label>
                                <InputText id="replyWithinDay" type="text" disabled={true} value={setValViewForm("replyWithinDay")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationBegin">บริเวณก่อสร้าง</label>
                                <InputText id="locationBegin" type="text" disabled={true} value={setValViewForm("locationBegin")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationEnd">ถึง</label>
                                <InputText id="locationEnd" type="text" disabled={true} value={setValViewForm("locationEnd")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeBegin">วันที่เวลาขอออกปฏิบัติงานจาก</label>
                                <InputText id="operateTimeBegin" type="text" disabled={true} value={setValViewForm("operateTimeBegin")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeEnd">วันที่เวลาขอออกปฏิบัติงานถึง</label>
                                <InputText id="operateTimeEnd" type="text" disabled={true} value={setValViewForm("operateTimeEnd")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="foremanName">หัวหน้างาน</label>
                                <InputText id="foremanName" type="text" disabled={true} value={setValViewForm("foremanName")} />
                            </div>
                        </div>
                        <br />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label>รายงานผล</label>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="fixedCheckbox" checked={setValViewForm("fixedCheckbox") === "Y" ? true : false} disabled={true} />
                                    <label htmlFor="fixedCheckbox">ปรับปรุง/แก้ไข แล้วเสร็จวันที่</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-2">
                                <InputText id="fixedDate" type="text" value={setValViewForm("fixedDate")} disabled={true} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="notDoneCheckbox" checked={setValViewForm("notDoneCheckbox") === "Y" ? true : false} disabled={true} />
                                    <label htmlFor="notDoneCheckbox">ไม่สามารถปรับปรุงแก้ไข ข้อ</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-2">
                                <InputText id="notDoneNo" type="text" value={setValViewForm("notDoneNo")} disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-sm-1" style={{ textAlign: "right" }}>
                                <label htmlFor="notDoneReason">เหตุผล</label>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <InputText id="notDoneReason" type="text" value={setValViewForm("notDoneReason")} disabled={true} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="otherCheckbox" checked={setValViewForm("otherCheckbox") === "Y" ? true : false} disabled={true} />
                                    <label htmlFor="otherCheckbox">อื่นๆ</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-7">
                                <InputText id="otherReason" type="text" value={setValViewForm("otherReason")} disabled={true} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtBegin">วันที่เวลาออกปฏิบัติงานจาก</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars key="reportDtBegin" id="reportDtBegin" value={new Date(reportDtBegin)} onChange={(e) => setReportDtBegin(e.target.value)} disabled={disPlayMode()} showTime={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtEnd">วันที่เวลาออกปฏิบัติงานถึง</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars key="reportDtEnd" id="reportDtEnd" value={new Date(reportDtEnd)} onChange={(e) => setReportDtEnd(e.target.value)} disabled={disPlayMode()} showTime={true} />
                            </div>
                        </div>
                        <br />

                        <P204List_2 dataTable={dataTbImage} viewImage={viewImage} />
                        <br />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-7">
                                <label htmlFor="supervisorReason">เหตุผล</label>
                                <span style={{ color: "red" }}>*</span>
                                <InputTextarea className={submitted && !supervisorReason ? "p-invalid" : ""} id="supervisorReason" type="text" rows="4" maxLength="500" value={supervisorReason} onChange={(e) => setSupervisorReason(e.target.value)} disabled={disPlayMode()} />
                                {submitted && !supervisorReason && validateInputText("supervisorReason", "เหตุผล")}
                            </div>
                        </div>
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button p-mr-2 p-mb-2" icon="pi pi-check" label="อนุมัติ" style={{ width: 170 }} onClick={() => handlerSettingDialogConfirm_2("A", "ต้องการอนุมัติรายงานผล หรือไม่")} disabled={disPlayMode()} />

                                <Button
                                    className="p-button-warning p-button p-mr-2 p-mb-2"
                                    icon="pi pi-ban"
                                    label="ส่งกลับแก้ไข"
                                    // style={{ marginLeft: '5px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => handlerSettingDialogConfirm_2("R", "ต้องการส่งกลับผู้รับเหมาแก้ไข")}
                                    disabled={disPlayMode()}
                                />
                                <Button
                                    className="p-button-secondary p-button p-mr-2 p-mb-2"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก"
                                    // style={{ marginLeft: '5px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => history.push("/200")}
                                />
                            </div>
                        </div>
                    </div>
                    <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
                    <DialogViewPic dialog={dialogPic} data={dialogPic.pic} modal setDialogPic={setDialogPic} />
                </div>
            </div>
        </>
    );
}
